/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react'
import {
  Button,
  Card,
  Col,
  Collapse,
  Container,
  OverlayTrigger,
  Popover,
  Row,
  Table
} from 'react-bootstrap'
import { Link, useLocation, useParams } from 'react-router-dom'
import { BadgeStatusPrLists } from '../../../components/atoms/StatusLabel'
import { ChevronDown, ChevronUp, FileDown } from 'lucide-react'
import styles from './request_return.module.css'
import { convertDateWithTime } from '../../../helpers/constants'
import api from '../../../config/AxiosInstance'
import * as Common from '../../../utils/Common'
import Loading from '../../../components/atoms/Loading'
import CustomButton from '../../../components/Button/CustomButton'
import ModalSelectFormat from '../../../components/modal/Sj/ModalSelectFormat'
import Swal from 'sweetalert2'

const headerTitleStyle = {
  color: 'var(--primary-orange)',
  fontSize: '18px',
  fontWeight: '600'
}

const tableHeaderStyle = {
  fontSize: '14px',
  fontWeight: '600',
  color: '#333333',
  letterSpacing: '0.5px',
  backgroundColor: '#f8f9fa',
  borderBottom: '2px solid #e9ecef'
}

const cardFilterStyle = {
  border: 'none',
  boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
  borderRadius: '12px',
  padding: '1.5rem',
  marginBottom: '1.5rem',
  backgroundColor: '#fff'
}

const labelStyle = {
  fontSize: '0.75rem',
  fontWeight: '700',
  color: '#333333',
  textTransform: 'uppercase',
  marginBottom: '0.5rem',
  letterSpacing: '0.5px'
}

function DetailRequestReturn() {
  const { code } = useParams()
  const { state } = useLocation()
  const [data, setData] = useState(null)
  const [commandCollapse, setCommandCollapse] = useState(true)
  const [progressCollapse, setProgressCollapse] = useState(true)
  const [iconCommand, setIconCommand] = useState('up')
  const [iconProgress, setIconProgress] = useState('up')
  const [loadingDownload, setLoadingDownload] = useState({})
  const [loading, setLoading] = useState(false)
  const [loadingDownloadAction, setLoadingDownloadAction] = useState({
    download: false,
    print: false,
    format: false
  })
  const [loadingSendToErp, setLoadingSendToErp] = useState(false)
  const [showModalSelectFormat, setShowModalSelectFormat] = useState(false)
  const [selectFormatDownload, setSelectFormatDownload] = useState({
    type: 'rr',
    format: null,
    action: null,
    id: null
  })
  const fetchData = async () => {
    try {
      setLoading(true)
      const params = {
        name: code
      }
      const res = await api.get('outbound/request-return/detail', { params })
      const { data: dataResponse } = res.data

      setData({
        ...dataResponse,
        command: dataResponse.command.map((command, index) => {
          return {
            ...command,
            id: index + 1
          }
        })
      })
    } catch (error) {
      const errMsg =
        error?.response?.data?.errors?.message ||
        error?.message ||
        'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    } finally {
      setLoading(false)
    }
  }
  const handleDownloadLabel = async (id, params) => {
    try {
      setLoadingDownload({
        ...loadingDownload,
        [id]: true
      })
      const res = await api.get('outbound/request-return/detail', {
        params,
        responseType: 'arraybuffer'
      })
      const { status, data: dataResponse } = res
      if (status === 200) {
        const blob = new Blob([dataResponse], { type: 'application/pdf' })
        const url = window.URL.createObjectURL(blob)

        const link = document.createElement('a')
        link.href = url
        link.setAttribute(
          'download',
          `download_label_${params.name}_${params.batch}.pdf`
        )
        document.body.appendChild(link)
        link.click()

        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
      }
    } catch (error) {
      const errMsg =
        error?.response?.data?.errors?.message ||
        error?.message ||
        'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    } finally {
      setLoadingDownload({
        ...loadingDownload,
        [id]: false
      })
    }
  }
  const renderLabel = (dataColumn) => (
    <div key={dataColumn.id}>
      <Button
        type="button"
        variant={loadingDownload[dataColumn.id] ? 'secondary' : 'warning'}
        className={`${
          !loadingDownload[dataColumn.id] ? 'text-light' : 'opacity-25'
        }`}
        onClick={() =>
          handleDownloadLabel(dataColumn.id, {
            name: encodeURIComponent(data?.draft_code || ''),
            batch: dataColumn?.batch || ''
          })
        }
      >
        <FileDown size={14} />
      </Button>
    </div>
  )
  const columns = [
    { key: 'sequence', label: 'No' },
    {
      key: 'item_name',
      label: 'Item Code - Name',
      component: (data) => (
        <div key={data.id}>
          <OverlayTrigger
            trigger={['hover', 'click']}
            key={'bottom'}
            placement={'bottom'}
            overlay={
              <Popover id={`popover-positioned-bottom`}>
                <Popover.Body>
                  <p className="text-center fw-bold text-uppercase">
                    item name
                  </p>
                  <p className="text-center">{data?.item_name || '-'}</p>
                  <p className="text-center fw-bold text-uppercase">
                    item alias
                  </p>
                  <p className="text-center">{data.item_alias || '-'}</p>
                  <p className="text-center fw-bold text-uppercase">
                    item code
                  </p>
                  <p className="text-center">{data?.item_code || '-'}</p>
                </Popover.Body>
              </Popover>
            }
          >
            <div
              className="p-2 align-middle cursor-pointer"
              role="button"
              tabIndex={0}
            >
              <div className="fw-bold text-dark">
                {data?.item_code || '-'} - {data?.item_name || '-'}
              </div>
            </div>
          </OverlayTrigger>
        </div>
      )
    },
    {
      key: 'item_alias',
      label: 'Item Alias',
      component: (data) => data.item_alias ?? '-'
    },
    {
      key: 'batch',
      label: 'Batch'
    },
    {
      key: 'total_qty',
      label: 'Base Qty UOM',
      component: (data) =>
        `${
          data.total_qty
            ? parseFloat(data.total_qty).toLocaleString('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              })
            : '0.00'
        } ${data.uom || ''}`
    },
    {
      key: 'total_pack',
      label: 'Qty Kemasan',
      component: (data) => `${data.total_pack || 0} ${data.uom_pack || ''}`
    },
    {
      key: 'label',
      label: 'Label',
      component: (data) => renderLabel(data)
    }
  ]
  const handleDownloadPrint = async () => {
    try {
      setLoadingDownloadAction((prev) => ({
        ...prev,
        [selectFormatDownload.action]: true,
        format: true
      }))
      const res = await api.get(
        `outbound/request-return/${encodeURIComponent(
          selectFormatDownload.id
        )}/file?print=${encodeURIComponent(selectFormatDownload?.format)}&action=${selectFormatDownload.action}`,
        {
          responseType:
            selectFormatDownload.action === 'print' ? 'text' : 'arraybuffer'
        }
      )
      const { status, data, headers } = res
      if (status === 200) {
        const contentType = headers?.['content-type'] || ''
        if (selectFormatDownload.action === 'print') {
          if (contentType.includes('text/html') || typeof data === 'string') {
            Common.printDocument(data, true)
          } else {
            const blob = new Blob([data], { type: 'application/pdf' })
            Common.printDocument(blob)
          }
        } else if (selectFormatDownload.action === 'download') {
          const blob = new Blob([data], { type: 'application/pdf' })
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          link.setAttribute(
            'download',
            `file-rr-${selectFormatDownload.id}.pdf`
          )
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          window.URL.revokeObjectURL(url)
        }
        setShowModalSelectFormat(false)
        setSelectFormatDownload({
          type: 'rr',
          format: null,
          action: null,
          id: null
        })
      }
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    } finally {
      setLoadingDownloadAction((prev) => ({
        ...prev,
        [selectFormatDownload.action]: false,
        format: false
      }))
    }
  }

  const handleSubmitToErp = async () => {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-primary-orange',
        cancelButton: 'btn btn-transparent',
        actions:
          'd-flex w-100 justify-content-end pt-4 ps-4 pe-4 separator-border-action-sweetalert'
      },
      buttonsStyling: false
    })
    swalWithBootstrapButtons
      .fire({
        title: 'Send to ERP?',
        text: 'This action can’t be repeated!',
        icon: 'warning',
        iconColor: '#828282',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Send!',
        cancelButtonText: 'Cancel',
        allowOutsideClick: false,
        reverseButtons: true,
        showCloseButton: true,
        didOpen: () => {
          const confirmButton = Swal.getConfirmButton()
          confirmButton.disabled = false
        },
        preConfirm: () => {
          const confirmButton = Swal.getConfirmButton()
          confirmButton.disabled = true
          return true
        }
      })
      .then(async (result) => {
        if (result.isConfirmed) {
          try {
            setLoadingSendToErp(true)
            const res = await api.post(
              `outbound/sjdraft/${data?.id}/send-erp-rr`
            )
            const { data: dataResponse } = res
            if (dataResponse.success) {
              Common.showPopUpSuccessMessage('Successfully send to ERP')
              fetchData()
            }
          } catch (error) {
            const err =
              error?.response?.data?.errors?.message || 'An error occurred'
            Common.showPopUpErrorMessage(err)
          } finally {
            setLoadingSendToErp(false)
          }
        } else {
          return false
        }
      })
  }
  const renderInfoItem = (label, value, col = 3) => (
    <Col md={col} className="mb-3">
      <small style={labelStyle}>{label}</small>
      <h5
        className="mt-1"
        style={{ fontSize: '1.05rem', wordBreak: 'break-word' }}
      >
        {value || '-'}
      </h5>
    </Col>
  )

  useEffect(() => {
    fetchData()
  }, [])

  if (loading) {
    return <Loading />
  }
  return (
    <div>
      <Container fluid className="px-4 mb-5">
        <Row className="mb-4">
          <Col md={12}>
            <div className="d-flex justify-content-between align-items-start">
              <div className="d-flex flex-column justify-content-start">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb fs-6 mb-1">
                    <li className="breadcrumb-item">
                      <Link
                        to="/outbound/request-return"
                        state={state}
                        className="text-decoration-none"
                      >
                        <span className="text-black fw-bold text-uppercase">
                          RR
                        </span>
                      </Link>
                    </li>
                    <li
                      className="breadcrumb-item sj-item active"
                      aria-current="page"
                    >
                      {data?.draft_code || ''}
                    </li>
                  </ol>
                </nav>
                <h6
                  style={headerTitleStyle}
                  className="d-flex align-items-center gap-2"
                >
                  {data?.draft_code}
                  <BadgeStatusPrLists text={data?.draft_status} />
                </h6>
              </div>
              {['done', 'submit'].includes(data?.draft_status) && (
                <div className="d-flex gap-2">
                  <CustomButton
                    variant={'transparent'}
                    style={{ borderColor: '#F89D1D', whiteSpace: 'nowrap' }}
                    classNameValue="text-light btn-primary-orange"
                    text={`${
                      loadingDownloadAction.download
                        ? 'Downloading...'
                        : 'Download SJ Return'
                    }`}
                    onClick={() => {
                      setShowModalSelectFormat(true)
                      setSelectFormatDownload((prevSelectFormatDownload) => ({
                        ...prevSelectFormatDownload,
                        id: data?.id,
                        action: 'download'
                      }))
                    }}
                  />
                  <CustomButton
                    variant={'transparent'}
                    style={{ whiteSpace: 'nowrap' }}
                    classNameValue="text-light btn-primary-blue"
                    text={`${
                      loadingDownloadAction.print
                        ? 'Printing...'
                        : 'Print SJ Return'
                    }`}
                    onClick={() => {
                      setShowModalSelectFormat(true)
                      setSelectFormatDownload((prevSelectFormatDownload) => ({
                        ...prevSelectFormatDownload,
                        id: data?.id,
                        action: 'print'
                      }))
                    }}
                  />
                </div>
              )}
            </div>
          </Col>
        </Row>

        <Card style={cardFilterStyle}>
          <Row>
            {renderInfoItem('#DC', data?.dc, 6)}
            {renderInfoItem('Customer', data?.customer, 6)}
            {renderInfoItem('Branch', data?.branch, 6)}
            {renderInfoItem('Source Warehouse', data?.source_warehouse, 6)}
            {renderInfoItem('Address', data?.customer_address, 12)}
            {renderInfoItem('Reason', data?.reason, 6)}
            {renderInfoItem(
              'Date',
              data?.date ? convertDateWithTime(data?.date, 'DD-MM-YYYY') : '-',
              3
            )}
            {renderInfoItem('#Outbound', data?.outbound, 3)}
          </Row>
        </Card>

        <Card style={cardFilterStyle}>
          <Row className="mb-3">
            <Col
              md={12}
              className="d-flex justify-content-between align-items-center"
            >
              <h5 className="fw-bold text-uppercase mb-0">Command</h5>
              {iconCommand === 'up' ? (
                <ChevronUp
                  size={20}
                  className="text-secondary cursor-pointer"
                  onClick={() => {
                    setCommandCollapse(!commandCollapse)
                    setIconCommand(commandCollapse ? 'down' : 'up')
                  }}
                />
              ) : (
                <ChevronDown
                  size={20}
                  className="text-secondary cursor-pointer"
                  onClick={() => {
                    setCommandCollapse(!commandCollapse)
                    setIconCommand(commandCollapse ? 'down' : 'up')
                  }}
                />
              )}
            </Col>
          </Row>
          <Collapse in={commandCollapse}>
            <div>
              <h6 className="text-uppercase text-muted fw-bold mt-1 mb-3">
                Request Return
              </h6>
              <Table
                responsive
                className="shadow-sm bg-white"
                style={{
                  fontSize: '13px',
                  borderRadius: '12px',
                  overflow: 'hidden',
                  marginBottom: 0
                }}
              >
                <thead style={{ backgroundColor: '#f8f9fa' }}>
                  <tr>
                    {columns.map((column) => (
                      <th
                        className="align-middle p-2"
                        key={column.key}
                        style={tableHeaderStyle}
                      >
                        <span>{column.label}</span>
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {data?.command?.length > 0 &&
                    data?.command?.map((item, index) => (
                      <tr key={`${item.id}-${index}`}>
                        {columns.map((column) => (
                          <td key={column.key} className="p-2 align-middle">
                            {column.key === 'sequence' && index + 1}
                            {column.component && column.component(item)}
                            {!column.component && item[column.key]}
                          </td>
                        ))}
                      </tr>
                    ))}
                </tbody>
              </Table>
            </div>
          </Collapse>
        </Card>

        {data?.draft_status === 'ongoing' &&
          data?.is_finish_loading &&
          data?.outbound && (
            <Row className="mb-4">
              <div className="d-flex justify-content-end">
                <Button
                  variant="transparent"
                  className={`${
                    loadingSendToErp
                      ? 'btn-secondary opacity-50'
                      : 'btn-primary-orange'
                  }`}
                  disabled={loadingSendToErp}
                  onClick={() => handleSubmitToErp()}
                >
                  {loadingSendToErp ? 'Sending...' : 'Send to ERP'}
                </Button>
              </div>
            </Row>
          )}

        <Card style={cardFilterStyle}>
          <Row className="mb-3">
            <Col
              md={12}
              className="d-flex justify-content-between align-items-center"
            >
              <h5 className="fw-bold text-uppercase mb-0">Progress Detail</h5>
              {iconProgress === 'up' ? (
                <ChevronUp
                  size={20}
                  className="text-secondary cursor-pointer"
                  onClick={() => {
                    setProgressCollapse(!progressCollapse)
                    setIconProgress(progressCollapse ? 'down' : 'up')
                  }}
                />
              ) : (
                <ChevronDown
                  size={20}
                  className="text-secondary cursor-pointer"
                  onClick={() => {
                    setProgressCollapse(!progressCollapse)
                    setIconProgress(progressCollapse ? 'down' : 'up')
                  }}
                />
              )}
            </Col>
          </Row>
          <Collapse in={progressCollapse}>
            <ul className="list-unstyled">
              {data?.progress?.length > 0 &&
                data?.progress?.map((progress, index) => (
                  <li key={index}>
                    <div className="d-flex flex-column flex-md-row flex-lg-row gap-3 progress-detail">
                      <div className="d-flex flex-row gap-2 gap-md-3 gap-lg-3">
                        <div className="circle-progress-detail"></div>
                        <p className="fs-6">{progress?.datetime}</p>
                      </div>
                      <div
                        className={`${styles.subProgressDetail} d-flex flex-column justify-content-center`}
                        style={{ height: '13px' }}
                      >
                        <div className="d-flex flex-row gap-3">
                          <div className="circle-small-progress-detail mt-2 ms-1"></div>
                          <span style={{ fontSize: '13px' }}>
                            {progress?.description}
                          </span>
                        </div>
                      </div>
                    </div>
                  </li>
                ))}
            </ul>
          </Collapse>
        </Card>

        <Card style={cardFilterStyle}>
          <Row>
            {renderInfoItem('CREATED BY', data?.created_by, 3)}
            {renderInfoItem(
              'CREATED AT',
              data?.created_at
                ? convertDateWithTime(data?.created_at, 'DD-MM-YYYY, HH:mm')
                : '-',
              3
            )}
            {renderInfoItem('LAST UPDATED BY', data?.updated_by, 3)}
            {renderInfoItem(
              'LAST UPDATED AT',
              data?.updated_at
                ? convertDateWithTime(data?.updated_at, 'DD-MM-YYYY, HH:mm')
                : '-',
              3
            )}
          </Row>
        </Card>
      </Container>
      <ModalSelectFormat
        show={showModalSelectFormat}
        handleClose={() => {
          setShowModalSelectFormat(false)
          setSelectFormatDownload((prevSelectFormatDownload) => ({
            ...prevSelectFormatDownload,
            id: null,
            format: null
          }))
        }}
        setSelectFormatDownload={setSelectFormatDownload}
        selectFormatDownload={selectFormatDownload}
        handleDownloadPrint={handleDownloadPrint}
        loadingFormat={loadingDownloadAction.format}
      />
    </div>
  )
}

export default DetailRequestReturn
